import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ModalProvider } from './contexts/ModalContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/about/index';
import PartnerProgramPage from './pages/partner-program/index';
import DirectoryPage from './pages/directory/index';
import ExpressionOfInterestPage from './pages/expression-of-interest/index';
import SignInPage from './pages/signin/index';
import ContactPage from './pages/contact/index';

import './styles/index.css';

// Component to handle anchor scrolling after navigation
function ScrollToAnchor() {
  const location = useLocation();

  useEffect(() => {
    // Only handle anchor scrolling if there's actually a hash in the URL
    console.log('ScrollToAnchor triggered:', { pathname: location.pathname, hash: location.hash });
    if (location.hash && location.hash.length > 1) {
      // Small delay to ensure the page has rendered
      setTimeout(() => {
        const element = document.getElementById(location.hash.substring(1));
        if (element) {
          console.log('ScrollToAnchor: Scrolling to element:', location.hash.substring(1));
          element.scrollIntoView({ behavior: 'smooth' });
        } else {
          console.log('ScrollToAnchor: Element not found:', location.hash.substring(1));
        }
      }, 100);
    }
  }, [location.pathname, location.hash]); // Only trigger on path or hash changes

  return null;
}

function App() {
  return (
    <AuthProvider>
      <ModalProvider>
        <Router>
          <ScrollToAnchor />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/partner-program" element={<PartnerProgramPage />} />
            <Route path="/directory" element={<DirectoryPage />} />
            <Route path="/expression-of-interest" element={<ExpressionOfInterestPage />} />
                             <Route path="/signin" element={<SignInPage />} />
            <Route path="/contact" element={<ContactPage />} />
            
            {/* Protected Routes - Future Partner Portal Access */}
            <Route 
              path="/portal" 
              element={
                <ProtectedRoute>
                  <Layout>
                    <div className="ph-page">
                      <div className="ph-page-header">
                        <h1 className="ph-page-title">Partner Portal</h1>
                        <p className="ph-page-subtitle">
                          Welcome to your Alliance Partner dashboard
                        </p>
                      </div>
                      <div className="ph-page-intro">
                        <p>
                          This area is under development. Soon you'll have access to:
                        </p>
                        <ul className="list-disc list-inside mt-4 space-y-2 text-gray-700">
                          <li>Partner training materials and certifications</li>
                          <li>Revenue tracking and commission reports</li>
                          <li>Marketing resources and co-branding materials</li>
                          <li>Network directory and collaboration tools</li>
                          <li>Support tickets and relationship management</li>
                        </ul>
                      </div>
                    </div>
                  </Layout>
                </ProtectedRoute>
              } 
            />
          </Routes>
        </Router>
      </ModalProvider>
    </AuthProvider>
  );
}

export default App; 